import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import COLOR_PRESETS from '../constants/colorPresets'

const PRESET_KEYS = Object.keys(COLOR_PRESETS)

function ColorPickerPopover({ currentPreset, onSelect, onClose }) {
  const ref = useRef(null)

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose()
    }
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [onClose])

  return (
    <div ref={ref} className="kb-color-picker">
      {PRESET_KEYS.map(key => (
        <button
          key={key}
          className={`kb-color-picker-swatch${key === currentPreset ? ' kb-color-picker-swatch--active' : ''}`}
          style={{ backgroundColor: COLOR_PRESETS[key].bg, borderColor: key === currentPreset ? COLOR_PRESETS[key].text : 'transparent' }}
          onClick={(e) => { e.stopPropagation(); onSelect(key) }}
          title={key}
        />
      ))}
    </div>
  )
}

ColorPickerPopover.propTypes = {
  currentPreset: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ColorPickerPopover
